export const FirstDonationLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
  >
    <g
      id="First_Donation_Badge_-_Locked"
      data-name="First Donation Badge - Locked"
      transform="translate(1 -5)"
    >
      <g
        id="Achievement_Icon"
        data-name="Achievement Icon"
        transform="translate(0 6)"
      >
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="24"
          cy="24"
          r="24"
          fill="#e6e6e6"
          stroke="#666"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <g
          id="Group_2448"
          data-name="Group 2448"
          transform="translate(-8.013 -9.916)"
        >
          <path
            id="Path_2035"
            data-name="Path 2035"
            d="M45.276,42.362V43.4a.341.341,0,0,0,.341.341h.724a.341.341,0,0,0,.341-.341V42.38a2.845,2.845,0,0,0,2.647-2.724c0-1.376-.692-2.111-2.553-2.712l-.094-.031v-2.64a2.4,2.4,0,0,1,1.191.92.341.341,0,0,0,.485.085l.614-.451a.341.341,0,0,0,.078-.47,3.727,3.727,0,0,0-2.368-1.489v-.855a.341.341,0,0,0-.341-.341h-.724a.341.341,0,0,0-.341.341v.824a2.613,2.613,0,0,0-2.443,2.547c0,1.225.763,2.048,2.4,2.588l.045.015V41a2.886,2.886,0,0,1-1.542-1,.342.342,0,0,0-.478-.041l-.573.478a.341.341,0,0,0-.045.48A4.189,4.189,0,0,0,45.276,42.362Zm1.406-3.909c1,.365,1.187.7,1.187,1.231a1.393,1.393,0,0,1-1.187,1.33ZM44.28,35.3a1.137,1.137,0,0,1,1-1.108v2.248C44.461,36.108,44.28,35.74,44.28,35.3Z"
            transform="translate(-13.931 -5.272)"
            fill="#666"
          />
          <path
            id="Path_2036"
            data-name="Path 2036"
            d="M37.5,42.866A10.433,10.433,0,1,0,27.068,32.433,10.445,10.445,0,0,0,37.5,42.866Zm0-19.5a9.068,9.068,0,1,1-9.068,9.068A9.078,9.078,0,0,1,37.5,23.365Z"
            transform="translate(-5.488 0)"
            fill="#666"
          />
          <path
            id="Path_2037"
            data-name="Path 2037"
            d="M44.3,62.383H42.25a.682.682,0,1,0,0,1.365H44.3a1.365,1.365,0,1,1,0,2.73H19.73a1.365,1.365,0,0,1,0-2.73h2.047a.682.682,0,0,0,0-1.365H19.73a2.73,2.73,0,1,0,0,5.459H44.3a2.73,2.73,0,1,0,0-5.459Z"
            transform="translate(0 -22.011)"
            fill="#666"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const FirstDonationUnlocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="55"
    viewBox="0 0 50 55"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d11947" />
        <stop offset="1" stopColor="#8d0034" />
      </linearGradient>
    </defs>
    <g
      id="First_Donation_Badge_-_Unlocked"
      data-name="First Donation Badge - Unlocked"
      transform="translate(1)"
    >
      <g
        id="Achievement_Icon"
        data-name="Achievement Icon"
        transform="translate(0 6)"
      >
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="24"
          cy="24"
          r="24"
          stroke="#8d0034"
          strokeLinecap="round"
          strokeWidth="2"
          fill="url(#linear-gradient)"
        />
        <g
          id="Group_2448"
          data-name="Group 2448"
          transform="translate(-8.013 -9.916)"
        >
          <path
            id="Path_2035"
            data-name="Path 2035"
            d="M45.276,42.362V43.4a.341.341,0,0,0,.341.341h.724a.341.341,0,0,0,.341-.341V42.38a2.845,2.845,0,0,0,2.647-2.724c0-1.376-.692-2.111-2.553-2.712l-.094-.031v-2.64a2.4,2.4,0,0,1,1.191.92.341.341,0,0,0,.485.085l.614-.451a.341.341,0,0,0,.078-.47,3.727,3.727,0,0,0-2.368-1.489v-.855a.341.341,0,0,0-.341-.341h-.724a.341.341,0,0,0-.341.341v.824a2.613,2.613,0,0,0-2.443,2.547c0,1.225.763,2.048,2.4,2.588l.045.015V41a2.886,2.886,0,0,1-1.542-1,.342.342,0,0,0-.478-.041l-.573.478a.341.341,0,0,0-.045.48A4.189,4.189,0,0,0,45.276,42.362Zm1.406-3.909c1,.365,1.187.7,1.187,1.231a1.393,1.393,0,0,1-1.187,1.33ZM44.28,35.3a1.137,1.137,0,0,1,1-1.108v2.248C44.461,36.108,44.28,35.74,44.28,35.3Z"
            transform="translate(-13.931 -5.272)"
            fill="#fff"
          />
          <path
            id="Path_2036"
            data-name="Path 2036"
            d="M37.5,42.866A10.433,10.433,0,1,0,27.068,32.433,10.445,10.445,0,0,0,37.5,42.866Zm0-19.5a9.068,9.068,0,1,1-9.068,9.068A9.078,9.078,0,0,1,37.5,23.365Z"
            transform="translate(-5.488 0)"
            fill="#fff"
          />
          <path
            id="Path_2037"
            data-name="Path 2037"
            d="M44.3,62.383H42.25a.682.682,0,1,0,0,1.365H44.3a1.365,1.365,0,1,1,0,2.73H19.73a1.365,1.365,0,0,1,0-2.73h2.047a.682.682,0,0,0,0-1.365H19.73a2.73,2.73,0,1,0,0,5.459H44.3a2.73,2.73,0,1,0,0-5.459Z"
            transform="translate(0 -22.011)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_2669" data-name="Group 2669" transform="translate(31)">
        <circle
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="8.5"
          cy="8.5"
          r="8.5"
          fill="#008a1c"
        />
        <g
          id="Check_Mark_-_S"
          data-name="Check Mark - S"
          transform="translate(4 5.29)"
        >
          <path
            id="Check_Mark_-_S-2"
            data-name="Check Mark - S"
            d="M9.381,2.22a.442.442,0,0,0-.639,0L3.572,7.414,1.262,5.136a.442.442,0,0,0-.631,0,.459.459,0,0,0,0,.639l2.63,2.6a.483.483,0,0,0,.32.131.459.459,0,0,0,.32-.139l5.481-5.53A.451.451,0,0,0,9.381,2.22Z"
            transform="translate(-0.502 -2.083)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);
